<template>
  <v-form v-model="isFormValid" ref="form">
    <div>
      <dashboard-header :text="item ? $t('employee.updateEmployee'): $t('employee.createEmployee')"
                        :on-back="onGoBack"/>
      <div class="d-flex justify-center align-center">
        <v-card elevation="0"
                class="card-border-10 w-75"
                :loading="loading">
          <v-card class="m-4"
                  outlined>
            <div class="d-flex custom-card-head p-4">
              <div class="d-inline text-sm-h5 ">{{ $t("nav.about") }}</div>
            </div>
            <v-divider class="m-0"></v-divider>
            <div class="px-6 pt-6">
              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('employee.name') }}</p>
              </div>
              <v-textarea
                  v-model="employee.name"
                  :placeholder="placeholderName"
                  :rules="ruleEmployeeName"
                  counter="255"
                  auto-grow
                  rows="1"
                  outlined
              >
              </v-textarea>
              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('account.email') }}</p>
              </div>
              <v-textarea
                  v-model="employee.email"
                  :placeholder="placeholderEmail"
                  :rules="ruleEmployeeEmail"
                  auto-grow
                  rows="1"
                  outlined
              >
              </v-textarea>
              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('account.phoneNumber') }}</p>
              </div>
              <div class="d-flex">
                <v-responsive max-width="80">
                  <v-text-field rows="1" readonly outlined style="margin-right: 10px" prefix="+84"></v-text-field>
                </v-responsive>
                <v-text-field
                    v-model="employee.phoneNumber"
                    :placeholder="placeholderPhoneNumber"
                    :rules="ruleEmployeePhoneNumber"
                    rows="1"
                    outlined
                >
              </v-text-field>
              </div>

              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('employee.selectTitle') }}</p>
              </div>
              <v-select
                  class="select-line-height"
                  v-model="selectedTitle"
                  :items="listTile"
                  :placeholder="select"
                  :rules="ruleEmployeeTitle"
                  item-text="name"
                  return-object
                  outlined
                  @change="onTitleChange">
              </v-select>
              <div class="d-flex">
                <div class="text-h6 mark-title">*</div>
                <p class="ms-1 text-sm-h5">{{ $t('employee.selectDepartment') }}</p>
              </div>
              <v-select
                  class="select-line-height"
                  v-model="selectedTargets"
                  :items="listTargets"
                  :placeholder="select"
                  :rules="ruleEmployeeDepartment"
                  item-text="name"
                  return-object                  
                  outlined
                  @change="onDepartmentChange">
              </v-select>
              
              
              
              <v-row>
                <v-col>
                  <div class="d-flex align-center">
                    <v-switch
                        inset
                        v-model="employee.doctorSosCall"
                        @change="onSwitchRedAlert"
                    ></v-switch>
                    <div class="text-sm-h5">{{ $t('ui.redAlertMobile') }}</div>
                  </div>
                  <div class="d-flex align-center">
                    <v-switch
                        inset
                        v-model="employee.inCharge"
                        :disabled="isDisabled"
                        @change="onSwitchInCharge"
                    ></v-switch>
                    <div class="text-sm-h5">{{ $t('employee.inCharge') }}</div>
                  </div>
                </v-col>
                <v-col>
                  <div class="d-flex align-center">
                    <v-switch
                        inset
                        v-model="employee.isGetNotifications"
                        @change="onSwitchNurse"
                    ></v-switch>
                    <div class="text-sm-h5">{{ $t('ui.activeNurseMobile') }}</div>
                  </div>
                  <!-- <div class="d-flex align-center"
                  >
                    <v-switch
                        inset
                        v-model="createFast"
                        v-if="isVisible"
                        @change="onSwitchCreateFast"
                    ></v-switch>
                    <div v-if="isVisible" class="text-sm-h5">{{ $t('ui.createFast') }}</div>
                  </div> -->
                </v-col>
              </v-row>
            </div>
          </v-card>
          <div class=" m-4">
            <v-btn
                elevation="0"
                class="no-uppercase btn-custom-primary"
                :disabled="!isFormValid"
                @click="onSave"
            >{{ $t('ui.save') }}
            </v-btn>
          </div>
        </v-card>
      </div>
    </div>
  </v-form>

</template>

<script>
import { cloneDeep } from "lodash";
import { API2 } from "../../api";
import mixin from "../../mixin";
import DashboardHeader from "../component/DashboardHeader";

export default {
  name: "Create",
  components: {DashboardHeader},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      isFormValid: false,
      listTargets: [],
      selectedTargets: null,
      selectedDepartmentId: null, // Store department ID separately
      createFast: 0,
      listTile: [],
      selectedTitle: null,
      selectedTitleId: null, // Store title ID separately
      employee: this.getDefaultEmployee(),
      employeeClone: this.getDefaultEmployee()
    }
  },

  computed: {
    isVisible() {
      return !this.item
    },
    isDisabled() {
      return false
      // return this.employeeClone.inCharge === 1 && this.employee.inCharge === 1
    },
    ruleEmployeeName() {
      return [
        this.employee.name.length > 0 && this.employee.name.length <= 255 || this.$t("ui.MSG0036"),
        this.employee.name.trim().length > 0 || this.$t("ui.MSG0036")
      ];
    },
    ruleEmployeeEmail() {
      const email = this.employee.email
      const localPartLength = email ? email.split('@')[0].length : 0
      return [
        email.length > 0 || this.$t("ui.MSG0105"),
        localPartLength <= 64 || this.$t("ui.MSG0036"),
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || this.$t("ui.MSG0037")
      ]
    },
    ruleEmployeePhoneNumber() {
      return [
        !!this.employee.phoneNumber.length || this.$t("ui.MSG0062"),
        this.employee.phoneNumber.length === 12 || this.employee.phoneNumber.length === 10 || this.$t("ui.MSG0062"),
        /^\+?[0-9]{9,15}$/.test(this.employee.phoneNumber) || this.$t("ui.MSG0062")
      ]
    },
    ruleEmployeeTitle() {
      return [!!this.selectedTitle || '']
    },
    ruleEmployeeDepartment() {
      return [!!this.selectedTargets || '']
    },
    
    placeholderName() {
      return this.$t('employee.enterName')
    },
    placeholderAccount() {
      return this.$t('ui.adminInfoName')
    },
    placeholderPhoneNumber() {
      return this.$t('employee.enterPhoneNumber')
    },
    placeholderTitle() {
      return this.$t('employee.selectJobTitle')
    },    
    placeholderEmail() {
      return this.$t('account.enterEmail')
    },
    select() {
      return this.$t('base.selectOption')
    }
  },
  mounted() {
    this.onTab(this.item)
  },
  methods: {
    onGoBack() {
      this.openTab(0)
    },
    async onTab(item) {
      this.$refs.form.resetValidation()
      this.employee = this.getDefaultEmployee()
      this.selectedTargets = null
      this.selectedTitle = null
      await this.getlistFilter();
      await this.getListTitle();
      if (item) await this.getData(item)
    },
    getDefaultEmployee() {
      return {
        name: '',
        email: '',
        phoneNumber: '',
      }
    },
    async getData(item) {
      // TODO api thiếu data của account, createFast
      let res = await this.get(API2.EMPLOYEE, {path: item.data.employeeId})
      if (res) {
        this.employee = res
        this.employeeClone = cloneDeep(this.employee);
      } else {
        this.onGoBack()
      }
    },
    async getlistFilter() {
      let res = await this.get(API2.DEPARTMENT)
      if (res) {
        this.listTargets = res.data?.map(i => ({... i, name: this.shortenText(i.name, 40)}));
        if (this.item) {
          this.selectedTargets = this.listTargets.find(departmentType =>
              departmentType.departmentId === this.item.departmentId
          );
          if (!this.selectedTargets) this.selectedTargets = this.listTargets[0];
          // Store the department ID
          if (this.selectedTargets) {
            this.selectedDepartmentId = this.selectedTargets.departmentId;
          }
        }
      }
    },
    async getListTitle() {
      let res = await this.get(API2.TITLE)
      if (res) {
        this.listTile = res.data?.map(i => ({... i, name: this.shortenText(i.name, 40)}));
        if (this.item) {
          this.selectedTitle = this.listTile.find(
              title =>
                  title.titleId === this.item.titleId
          );
          if (!this.selectedTitle) this.selectedTitle = this.listTile[0];
          // Store the title ID
          if (this.selectedTitle) {
            this.selectedTitleId = this.selectedTitle.titleId;
          }
        }
      }
    },
    async onSave() {
      let data = {
        name: this.employee.name,
        email: this.employee.email,
        phoneNumber: this.employee.phoneNumber,
        inCharge: this.employee.inCharge ? 1 : 0,
        isGetNotifications: this.employee.isGetNotifications ? 1 : 0,
        doctorSosCall: this.employee.doctorSosCall ? 1 : 0,
        createFast: this.createFast ? 1 : 0,
        webAccess: 1,
        // Use stored IDs if available, fallback to selected object IDs
        titleId: this.selectedTitleId || (this.selectedTitle ? this.selectedTitle.titleId : null),
        departmentId: this.selectedDepartmentId || (this.selectedTargets ? this.selectedTargets.departmentId : null),
      }
      if (this.item) data.path = this.employee.employeeId
      let res = this.item ? await this.put(API2.EMPLOYEE, data) : await this.post(API2.EMPLOYEE, data)
      if (!res) return
      this.showToast("success", this.$t('ui.toastSuccess'), '')
      this.openTab(0)
    },
    onDepartmentChange(value) {
      // Store the department ID when selected
      if (value && value.departmentId) {
        this.selectedDepartmentId = value.departmentId;
      }
    },
    onTitleChange(value) {
      // Store the title ID when selected
      if (value && value.titleId) {
        this.selectedTitleId = value.titleId;
      }
    },
    onSwitchInCharge(newValue) {
      this.employee.inCharge = newValue ? 1 : 0
    },
    onSwitchNurse(newValue) {
      this.employee.isGetNotifications = newValue ? 1 : 0
    },
    onSwitchCreateFast(newValue) {
      this.createFast = newValue ? 1 : 0
    },
    onSwitchRedAlert(newValue) {
      this.employee.doctorSosCall = newValue ? 1 : 0
    },
    shortenText(text, maxLength) {
      return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
    },
  },
}
</script>

<style scoped>

.v-input {
  font-size: 22px;
}

.card-border-10 >>> .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: rgba(217, 217, 217, 1);
}

.select-line-height>>>.v-select__selections {
  line-height: 24px !important;
}

</style>